module.exports = __webpack_public_path__ + "img/ic_programs_active.9ad41ae6.png";